import errorHandler from './error-handler';

export default {
  errorHandler,
};
